import { useMemo } from 'react';
import { isAfter, startOfDay } from 'date-fns';
import { pathgen } from 'object-path-generator';
import { Column, Typography } from 'seagull';
import { useIoContext } from "../../../../../contexts";
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import { serviceBillingModel } from "../../../../../models";
import { formatShortMonthUSDate } from "../../../../../utils";
import { autoBillingPeriodLabel } from "../../../../../utils/service-billing/automatic-service-billing-period";
import styles from "../ServicesSection.module.scss";
import OngoingServiceSwitch from "./OngoingServiceSwitch";
import ServiceTitle from "./ServiceTitle";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AutomaticServiceBillingItemTestIds = pathgen('AutomaticServiceBillingItemTestIds');
export default function AutomaticServiceBillingItem(props) {
  const {
    serviceName,
    serviceId,
    costDisplay,
    billing,
    idx,
    agreement,
    disabled,
    tooltipTitle,
    qboItemName,
    xeroItemName,
    qboClassName,
    startBillingAt
  } = props;
  const maxCharges = serviceBillingModel.maxCharges(billing);
  const {
    START_BILLING_AT
  } = useFeatureFlags();
  const billingPeriodLabel = autoBillingPeriodLabel(billing);
  const {
    getNow
  } = useIoContext();
  const now = useMemo(() => getNow(), []);
  const shouldShowStartBillingAt = () => {
    return START_BILLING_AT && startBillingAt && isAfter(startBillingAt, startOfDay(now));
  };
  return /*#__PURE__*/_jsxs("li", {
    "data-testid": "service-".concat(idx),
    className: styles.serviceBox,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.serviceDescription,
      children: [/*#__PURE__*/_jsx(ServiceTitle, {
        name: serviceName,
        serviceId: serviceId,
        qboItemName: qboItemName,
        xeroItemName: xeroItemName,
        qboClassName: qboClassName,
        noWrap: true
      }), /*#__PURE__*/_jsxs(Column, {
        gap: 4,
        children: [/*#__PURE__*/_jsx(Typography, {
          noWrap: true,
          "data-testid": "cost",
          variant: "paragraph2",
          skin: "secondary",
          children: costDisplay
        }), startBillingAt && shouldShowStartBillingAt() ? /*#__PURE__*/_jsxs(Typography, {
          noWrap: true,
          "data-testid": AutomaticServiceBillingItemTestIds.StartBillingAt(),
          variant: "paragraph2",
          skin: "secondary",
          children: ["Scheduled to start on ", formatShortMonthUSDate(startBillingAt)]
        }) : billingPeriodLabel ? /*#__PURE__*/_jsx(Typography, {
          noWrap: true,
          "data-testid": "billing",
          variant: "paragraph2",
          skin: "secondary",
          children: billingPeriodLabel.text
        }) : null]
      }), (maxCharges === null || maxCharges === void 0 ? void 0 : maxCharges.enabled) && maxCharges.limit && /*#__PURE__*/_jsxs(Typography, {
        noWrap: true,
        "data-testid": "max-charges-added-indicator",
        variant: "paragraph2",
        skin: "secondary",
        children: [maxCharges.limit - (maxCharges.chargesLeft || 0), "/", maxCharges.limit, " times billed"]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.lineItemAction,
      children: /*#__PURE__*/_jsx(OngoingServiceSwitch, {
        "data-testid": "billing-control-service-".concat(idx, "-switch"),
        agreementId: agreement.id,
        serviceId: serviceId,
        serviceName: serviceName,
        isPaused: serviceBillingModel.isPaused(billing),
        isDisabled: disabled,
        tooltipTitle: tooltipTitle
      })
    })]
  });
}